import { render } from "./custom-field.component.vue?vue&type=template&id=a04ecc9e&ts=true"
import script from "./custom-field.component.vue?vue&type=script&lang=ts"
export * from "./custom-field.component.vue?vue&type=script&lang=ts"

import "./custom-field.component.vue?vue&type=style&index=0&id=a04ecc9e&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__